<template>
  <div class="state">
    <div class="top-title" v-if="!recaptcha">
      <!-- <div v-if="!recaptcha"> -->
      {{ $t("验证码已发送至") }}{{ loginForm.account }}
      {{ $t("请输入邮箱内验证码进行重置密码") }}
      <!-- </div> -->
    </div>
    <div class="inform">
      <el-form :model="regForm" status-icon :rules="regRules" ref="regRef">
        <!-- 验证码 -->
        <el-form-item prop="code" class="yan">
          <el-input
            v-model="regForm.code"
            :placeholder="$t('请输入验证码')"
            class="code"
            autocomplete="off"
          ></el-input>
          <el-button
            type="primary"
            v-if="recaptcha"
            @click="sentCode"
            class="sentBut co bco"
            >{{ $t("发送验证码") }}</el-button
          >
          <el-button
            type="primary"
            :disabled="true"
            v-if="!recaptcha"
            class="sentBut co bco"
            >{{ time }}s{{ $t("重新发送") }}</el-button
          >
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password" class="pas">
          <el-input
            class="pas"
            v-model="regForm.password"
            :placeholder="$t('新密码')"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!-- 再次输入密码 -->
        <el-form-item prop="passwordone" class="pas">
          <el-input
            class="pas"
            v-model="regForm.passwordone"
            :placeholder="$t('确认密码')"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="unsigned">
          <el-button type="primary" @click="gotoReg" class="regist co bco">{{
            $t("提交")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import { reset_pwdApi, registerApi } from "@/api";
export default {
  props: ["loginForm"],
  data() {
    const verify = (rule, value, callback) => {
      if (!value) {
        // 验证失败
        callback(new Error(this.$t("验证码不能为空")));
      } else {
        callback();
      }
    };
    const samePwd = (rule, value, callback) => {
      if (value !== this.regForm.password) {
        // 如果验证失败，则调用 回调函数时，指定一个 Error 对象。
        callback(new Error(this.$t("两次输入的密码不一致!")));
      } else {
        // 如果验证成功，则直接调用 callback 回调函数即可。
        callback();
      }
    };
    return {
      regForm: {
        lang: null,
        email: "",
        code: "",
        password: "",
        passwordone: "",
      },
      // 发送验证码按钮的显示标识
      recaptcha: true,
      // 验证码倒计时
      time: null,
      // 注册表单的验证规则对象
      regRules: {
        // 验证验证码是否为空
        code: [
          { required: true, message: this.$t("请输入验证码"), trigger: "blur" },
          { validator: verify, trigger: "blur" },
        ],
        // 验证首次密码格式
        password: [
          { required: true, message: this.$t("请输入密码"), trigger: "blur" },
          {
            pattern: /^\S{6,18}$/,
            message: this.$t("密码必须是的非空字符"),
            trigger: "blur",
          },
        ],
        // 验证二次密码格式
        passwordone: [
          {
            required: true,
            message: this.$t("请再次输入密码"),
            trigger: "blur",
          },
          {
            pattern: /^\S{6,18}$/,
            message: this.$t("密码必须是的非空字符"),
            trigger: "blur",
          },
          { validator: samePwd, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async gotoReg() {
      this.$refs.regRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await reset_pwdApi({
          lang: this.loginForm.lang,
          email: this.loginForm.account,
          code: this.regForm.code,
          password: this.regForm.password,
          passwordone: this.regForm.passwordone,
        });
        // console.log("xin", res);
        if (res.code == 1) {
          let passWord = Base64.encode(this.regForm.password);
          localStorage.setItem("password", passWord);
          this.regForm.code = null;
          this.regForm.password = "";
          this.regForm.passwordone = "";
          this.$router.push("/over");
        }
      });
    },
    // 发送验证码
    async sentCode() {
      const { data: res } = await registerApi(
        this.loginForm.account,
        "resetpwd",
        this.loginForm.lang
      );
      // console.log(res);
      this.time = 60;
      if (res.code === 1) {
        this.recaptcha = false;
        var that = this;
        var timer = setInterval(function () {
          that.time--;
          // console.log(that.time);
          if (that.time == 0) {
            clearInterval(timer);
            that.recaptcha = true;
          }
        }, 1000);
      } else {
        return this.$message.error(res.msg);
      }
      // console.log("找回", res);
    },
  },
};
</script>

<style lang="less" scoped>
.top-title {
  // width: 270px;
  height: 41px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  margin-bottom: 22px;

  line-height: 25px;
}
.code {
  width: 245px;
  height: 51px;
  background: #ffffff;
  border-radius: 4px;
}
.sentBut {
  width: 126px;
  height: 50px;
  background: #3b5ff0;
  border-radius: 4px;
  margin-left: 20px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  border-color: transparent;
}
.pas {
  width: 391px !important;
  height: 51px;
}
.inform {
  padding-right: 35px;
}
.regist {
  width: 176px;
  height: 50px;
  background: #3b5ff0;
  border-radius: 4px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  margin-left: 87px;
  border-color: transparent;
}
.yan {
  width: 400px !important;
}
</style>
